'use strict';

export default QuantityControl;

function QuantityControl(element) {
  if (!(this instanceof QuantityControl)) {
    return new QuantityControl(element);
  }

  this.update();

  element.delegate('[data-quantity-plus]', 'click', function(e) {
    e.preventDefault();

    var fieldName = $(this).data('quantity-target');
    var $target = $('#' + fieldName);

    // Get its current value
    var currentVal = parseInt($target.val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      currentVal = currentVal + 1;
    } else {
      // Otherwise put a 0 there
      currentVal = 1;
    }
    $target.val(currentVal);
    $('[data-quantity-display]').html(currentVal);

    $(document).trigger('quantity-change', $target);
  });

  element.delegate('[data-quantity-minus]', 'click', function(e) {
    e.preventDefault();

    var fieldName = $(this).data('quantity-target');
    var $target = $('#' + fieldName);

    // Get its current value
    var currentVal = parseInt($target.val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      currentVal = currentVal - 1;
    } else {
      currentVal = 1;
    }
    $target.val(currentVal);
    $('[data-quantity-display]').html(currentVal);

    $(document).trigger('quantity-change', $target);
  });
}

QuantityControl.prototype.update = function() {
  $('[data-quantity-display]').each(function(i, el) {
    var target = $(el).data('quantity-target');
    var value = $('#' + target).val();
    $(el).html(value);
  });
};
